import { IApplicationEmbedStyle } from '../models/index.js';
export const applicationEmbedStyle: IApplicationEmbedStyle = {};
